var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n    font-family: \"GilroyRegular\";\r\n    src: local(\"GilroyRegular\"), url(" + escape(require("../../fonts/Gilroy-Regular.ttf")) + ") format(\"truetype\");\r\n    font-weight: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"GilroyBold\";\r\n    src: local(\"GilroyRegular\"), url(" + escape(require("../../fonts/Gilroy-Bold.ttf")) + ") format(\"truetype\");\r\n    font-weight: bold;\r\n}\r\n\r\n.dx-button {\r\n    border-radius: 0px;\r\n    border-width: 0px;\r\n    font-family: GilroyRegular;\r\n    font-size: 16px;\r\n}\r\n\r\n.body {\r\n    font-family: GilroyRegular;\r\n}\r\n\r\n.dx-widget {\r\n    font-family: GilroyRegular;\r\n}\r\n\r\n.panel-default .panel-heading {\r\n    background-image: none;\r\n    background-color: #242D4B;\r\n    font-family: GilroyRegular;\r\n    font-size: 16px;\r\n    color: white;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/app.css
// module id = 654
// module chunks = 0